import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'components/elements';
import { colors, media, fontWeight, fonts } from 'settings/style';

export const GroupCardLink = styled(Link)`
  background-color: ${colors.white};
  height: 146px;
  width: 100%;
  display: flex;
  border: 1px solid ${colors.cardBorder};
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
  border-radius: 14px;
  overflow: hidden;
  color: ${colors.grey900};
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    color: ${colors.grey900};
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
    transform: translateY(-1px);
  }

  ${media.xs`
    height: 132px;
  `}
`;

export const CardImage = styled.div<{ $coverUrl: string }>`
  flex: 0 0 34%;
  min-width: 118px;
  background-image: url(${({ $coverUrl }) => $coverUrl});
  background-color: #e8ecf1;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  border-radius: 14px 0 0 14px;

  ${media.xs`
    min-width: 102px;
  `}
`;

export const BadgeRow = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  max-width: calc(100% - 16px);
`;

export const MemberBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: ${fontWeight.bold};
  border: 1px solid ${colors.cardBorder};
  background-color: white;
  color: black;
`;

export const MemberIconWrap = styled.span`
  display: inline-flex;
  font-size: 11px;
  line-height: 1;
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 140px;
  border-radius: 6px;
  padding: 6px 9px;
  font-size: 11px;
  font-weight: ${fontWeight.bold};
  color: #000;
  background-color: #fff;
  overflow: hidden;

  span {
    display: inline-block;
    white-space: nowrap;
    padding-right: 16px;
    animation: status-pill-scroll 8s linear infinite;
    will-change: transform;
  }

  &:hover span {
    animation-play-state: paused;
  }

  @keyframes status-pill-scroll {
    0%,
    20% {
      transform: translateX(0);
    }
    80%,
    100% {
      transform: translateX(-100%);
    }
  }
`;

export const CardContent = styled.div`
  flex: 1;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  min-width: 0;

  ${media.xs`
    padding: 12px 13px;
  `}
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
`;

export const GroupTitle = styled.h4`
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 600;
  font-family: ${fonts.quaternary};
  color: ${colors.grey900};
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
  min-width: 0;

  ${media.xs`
    font-size: 15px;
  `}
`;

export const GroupDescription = styled.p`
  margin: 8px 0 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #667085;

  ${media.xs`
    margin-top: 6px;
    -webkit-line-clamp: 2;
  `}
`;

export const EditIconButton = styled(Button)`
  flex-shrink: 0;
  border: none;
`;
